export default __webpack_public_path__ + "static/media/Copy of variety-is-the-spice-of-authentication.3f7fde8d.jpg";